import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "h-full fixed app-sidebar-container" }
const _hoisted_2 = { class: "border-noround fixed app-sidebar mt-2 panel-menu" }

import { MenuItem } from 'primevue/menuitem';
import { computed, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import {Modal} from "@/store/classes";
import {useRootStore} from "@/store";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppMenu.vue3',
  props: {
    items: {},
    showMessageAction: { type: Boolean, default: false }
  },
  setup(__props: any) {

const route = useRoute();
const rootStore = useRootStore();

const props = __props;

const showModal = (modal: Modal) => rootStore.dispatch('showModal', modal);

const navItems = computed(() => {
    return props.items.map(x => ({
        ...x,
        key: (x.key || x.label)?.toString()
    }))
})

const expandedKeys = ref<Record<string, boolean>>({});

const hasActiveChild = (item: MenuItem, currentPath: string = route.path): boolean => {
    if (!item.items || item.items.length === 0) return false;
    return item.items.some(child => currentPath.startsWith(child.to));
};

watch(() => route.path, path => {
    const newKeys: Record<string, boolean> = {};
    
    // Find parent with active child and expand them
    navItems.value.forEach(item => {
        if (hasActiveChild(item, path) && item.key) {
            newKeys[item.key] = true;
        }
    });
    
    expandedKeys.value = newKeys;
}, { immediate: true });

async function showAddMessageModal() {
    await showModal({
        name: 'MessageModal',
        props: {
            title: 'Compose Message'
        }
    });
}

return (_ctx: any,_cache: any) => {
  const _component_p_button = _resolveComponent("p-button")!
  const _component_p_badge = _resolveComponent("p-badge")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_p_panel_menu = _resolveComponent("p-panel-menu")!

  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.showMessageAction)
        ? (_openBlock(), _createBlock(_component_p_button, {
            key: 0,
            class: "text-white p-button-rounded mb-2 mt-1 ml-2",
            label: "New Message",
            icon: "pi pi-comment",
            onClick: showAddMessageModal
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_p_panel_menu, {
        "expanded-keys": expandedKeys.value,
        "onUpdate:expandedKeys": _cache[0] || (_cache[0] = ($event: any) => ((expandedKeys).value = $event)),
        model: navItems.value,
        unstyled: true
      }, {
        item: _withCtx(({ item, props: itemProps }) => [
          _createVNode(_component_router_link, _mergeProps({
            to: item.to || ''
          }, itemProps.action, {
            class: ["p-menuitem-link flex align-items-center", { 'active-link': item.to ? (_unref(route).path.startsWith(item.to)) : hasActiveChild(item) }]
          }), {
            default: _withCtx(() => [
              (item.icon)
                ? (_openBlock(), _createElementBlock("i", {
                    key: 0,
                    class: _normalizeClass([item.icon, 'mr-2'])
                  }, null, 2))
                : _createCommentVNode("", true),
              _createElementVNode("span", null, _toDisplayString(item.label), 1),
              (item.badge)
                ? (_openBlock(), _createBlock(_component_p_badge, {
                    key: 1,
                    severity: "danger",
                    value: item.badge,
                    class: "ml-2"
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true),
              (item.items && item.items.length > 0)
                ? (_openBlock(), _createElementBlock("i", {
                    key: 2,
                    class: _normalizeClass([ 'pi ml-auto', expandedKeys.value[item.key] ? 'pi-chevron-down' : 'pi-chevron-right' ])
                  }, null, 2))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1040, ["to", "class"])
        ]),
        _: 1
      }, 8, ["expanded-keys", "model"])
    ])
  ]))
}
}

})